<template>
    <div class="confirm-pop">
        <div class="mask">
            <div class="content">
                <div class="icon">
                    <!-- <img src="@/assets/MusicConfirm/icon.png" alt="" /> -->
                </div>
                <div class="text"><slot name="text" /></div>
                <div class="button-set">
                    <div class="button cancel" @click="onInteractive(false)">
                        關閉
                    </div>
                    <div class="button ok" @click="onInteractive(true)">
                        開啟
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    prop: {

    },
    methods: {
        onInteractive(open) {
            this.$emit('interact', open);
        },
    },
};
</script>

<style lang="scss" scoped>
.confirm-pop {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100%;
    height: 100%;
    .mask {
        position: relative;
        width: 100%;
        height: 100%;
        background-color: #000000af;
        .content {
            position: absolute;
            padding: 30px 0;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 80%;
            max-width: 300px;
            background-color: #fff;
            display: flex;
            flex-direction: column;
            align-items: center;
            border-radius: 5px;
            box-shadow: 0 0 10px 0 rgba(0, 152, 201, 0.37);
        }
        .icon {
            width: 40%;
            img {
                width: 100%;
            }
        }
        .text {
            margin: 20px 0;
            color: #003a5d;
            font-size: 24px;
            font-weight: bold;
            text-align: center;
            letter-spacing: 1px;
        }
    }
    .button-set {
        display: flex;
        width: 80%;
        justify-content: space-between;
        .button {
            cursor: pointer;
            color: #ffffff;
            font-size: 24px;
            padding: 6px;
            text-align: center;
            width: 48%;
            border-radius: 49.3px;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .ok {
            background-color: #3ca1eb;
        }
        .cancel {
            background-color: #bbb;
        }
    }
}
</style>
